import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import hr_HR from "antd/locale/hr_HR";
import { useDispatch } from "react-redux";
import { checkAuth } from "./store/slices/authSlice";
import type { AppDispatch } from "./store/store";

// Layouts
import MainLayout from "./components/layouts/MainLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Pages
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import UserDashboard from "./pages/user/Dashboard";
import WaterMeters from "./pages/admin/WaterMeters";
import Readings from "./pages/user/Readings";
import Issues from "./pages/Issues";
import Profile from "./pages/Profile";
import NotFound from "./pages/NotFound";
import Unauthorized from "./pages/Unauthorized";
import { useAppDispatch } from "./store/hooks";

// Styles
 import "./App.css";
import Register from "components/auth/Register";
import UserManagement from "components/users/UserManagement";
import FaultReportForm from "components/faults/FaultReportForm";
import FaultReportList from "components/faults/FaultReportList";
import FaultNotifications from "components/faults/FaultNotifications";
import NotificationSettings from "pages/notifications/Settings";
import AreaManagement from "pages/admin/notifications/AreaManagement";
import NotificationEdit from "pages/admin/notifications/NotificationEdit";
import NotificationCreate from "pages/admin/notifications/NotificationCreate";
import BillHistory from "components/readings/BillHistory";
import WaterMeterManagement from "components/watermeters/WaterMeterManagement";
import Privacy from "./pages/Privacy";
import AccountDeletion from "./pages/AccountDeletion";
import NotificationManagement from "./pages/admin/NotificationManagement";
import ImportCenter from "./pages/admin/ImportCenter";
import BillingManagement from "./pages/admin/BillingManagement";
import OperationsSettings from "./pages/admin/OperationsSettings";

const App: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    //  dispatch(checkAuth());
  }, [dispatch]);

  return (
    <ConfigProvider
      locale={hr_HR}
      theme={{
        token: {
          colorPrimary: "#0950cd",
          borderRadius: 8,
        },
      }}
    >
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Admin routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="administrator">
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="water-meters" element={<WaterMeterManagement />} />
            <Route path="bills" element={<BillingManagement />} />
            <Route path="imports" element={<ImportCenter />} />
            <Route path="issues" element={<FaultReportList />} />

            <Route path="notifications" element={<NotificationManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="notifications/create" element={<NotificationCreate />} />
<Route path="notifications/:id/edit" element={<NotificationEdit />} />
<Route path="areas" element={<AreaManagement />} />
            <Route path="settings" element={<OperationsSettings />} />
          </Route>

          {/* User routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute requiredRole="subscriber">
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<UserDashboard />} />
            <Route path="/bills" element={<BillHistory />} />

            <Route path="issues" element={<FaultReportList />} />
            <Route path="notifications/settings" element={<NotificationSettings />} />

            <Route path="issues/new" element={<FaultReportForm />} />
            <Route path="notifications" element={<FaultNotifications />} />
            <Route path="readings" element={<Readings />} />
            <Route path="issues" element={<Issues />} />
            <Route path="profile" element={<Profile />} />
          </Route>

          {/* Redirect root to appropriate dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
